import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import "./Message.css";
import messageuser2 from "../../Assets/Img/message2.png";
import messagesend from "../../Assets/Img/messagesend.png";
import nouser from "../../Assets/Img/rafiki.svg";

const API_BASE_URL = "http://localhost:5000/api/chat";
// const userData = JSON.parse(localStorage.getItem("user") || "{}");
const userRaw = localStorage.getItem("user");

let userData = {};
try {
  userData = userRaw ? JSON.parse(userRaw) : {};
} catch (error) {
  console.error("Error parsing user data from localStorage:", error);
}

const CURRENT_USER_ID = userData?.user?.user_id;

const socket = io("http://localhost:5000", {
  autoConnect: false, // Keep manual connection
  reconnection: true, // Enable automatic reconnection
  reconnectionAttempts: 5, // Try 5 times before giving up
  reconnectionDelay: 2000,
});
// // Prevent auto-connect

export default function ChatInterface() {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [conversationId, setConversationId] = useState(null);

  const scrollToBottom = () => {
    const chatContainer = document.querySelector(".chat-messages");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };


  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (conversationId) {
      fetchMessages(conversationId);

      socket.connect(); // Manually connect socket
      socket.emit("joinConversation", conversationId);

      const handleNewMessage = (message) => {
        setMessages((prevMessages) => [...prevMessages, message]);
      };

      socket.on("sendMessage", handleNewMessage); // Listen to correct event
      socket.on("updateConversations", fetchMessages); // Listen to correct event

      return () => {
        socket.off("sendMessage", handleNewMessage);
        socket.off("updateConversations", fetchMessages);
        socket.disconnect("disconnect");
      };
    }
  }, [conversationId, newMessage]);

  // Fetch Users and Their Conversations
  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/conversation/${CURRENT_USER_ID}`);
      const text = await response.text(); // Get raw response
      console.log("Raw API response:", text);

      const data = JSON.parse(text);


      const users = data.map((item) => ({
        id: item.user.id,
        email: item.user.email,
        fullName: item.user.fullName || "Unknown User",
        profilePhoto: item.user.user_profile || messageuser2,
        conversationId: item.conversationId,
        last_msg: item.last_msg,
        last_message_sent_at: item.last_message_sent_at,
      }));

      // Sort users by last message timestamp (latest first)
      users.sort((a, b) => new Date(b.last_message_sent_at) - new Date(a.last_message_sent_at));

      setUserInfo(users);

      // Auto-select the most recent conversation
      if (users.length > 0) {
        setSelectedUser(users[0]);
        setConversationId(users[0].conversationId);
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };


  useEffect(() => {
    if (conversationId) {
      fetchMessages(conversationId);
    }
  }, [conversationId, messages]);


  // Fetch Messages for Selected Conversation
  const fetchMessages = async (convId) => {
    try {
      if (!convId) return;
      const response = await fetch(`${API_BASE_URL}/message/${convId}`);
      const data = await response.json();
      // console.log("kanj:",data);cls

      setMessages(data);

      // Wait for state update and scroll to bottom
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };


  // Handle User Selection
  const handleUserClick = (user) => {
    setSelectedUser(user);
    setConversationId(user.conversationId);
  };

  // Send Message
  const handleSendMessage = async () => {
    if (newMessage.trim() === "" || !selectedUser || !conversationId) return;

    const messageData = {
      conversationId,
      senderId: CURRENT_USER_ID,
      receiverId: selectedUser.id,
      message: newMessage,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(messageData),
      });

      if (!response.ok) throw new Error("Failed to send message");

      setNewMessage(""); // Clear input
      // fetchMessages(messageData.conversationId);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // time in all get message
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = { weekday: "short", hour: "2-digit", minute: "2-digit", hour12: true };
    return date.toLocaleString("en-US", options);
  };

  const [visibleTimestamp, setVisibleTimestamp] = useState(null);

  const toggleTimestamp = (index) => {
    setVisibleTimestamp(visibleTimestamp === index ? null : index);
  };


  return (


    <div className="chat-container" >
      {userInfo.length === 0 ? (
        <div className="text-center px-4 max-w-md mx-auto" style={{ marginTop: "8%" }}>
          <div style={{
            maxWidth: "100%",     // Ensures responsiveness
            width: "auto",       // Matches the design
            height: "auto"        // Maintains aspect ratio
          }}>
            <img src={nouser} alt="No user" className="object-contain" />
          </div>
          <h2 className="Title">Welcome to the chat!</h2>
          <p className="text-gray-600 mb-8" style={{fontSize: "24px",color:"#676767"}}>
            It looks like there are no messages yet. </p>
          <p className="text-gray-600 mb-8" style={{fontSize: "24px",color:"#676767"}}>
            Start a conversation now and connect with others!
          </p>
        </div>
      )
        :
        (<>
          {/* Sidebar for Users */}
          <div className="sidebar">
            <div className="sidebar-search">
              <i className="fas fa-search"></i>
              <input type="text" placeholder="Search for Brands" />
            </div>

            <div className="sidebar-users">
              {userInfo.length > 0 ? (
                userInfo.map((user) => (
                  <div
                    key={user.id}
                    className={`sidebar-user-item ${selectedUser?.id === user.id ? "selected" : ""}`}
                    onClick={() => handleUserClick(user)}
                    style={{ cursor: "pointer", padding: "10px", borderBottom: "1px solid #ddd" }}
                  >
                    <div className="sidebar-user-avatar">
                      <img src={user?.profilePhoto} alt="User" />
                    </div>

                    <div className="sidebar-user-info">
                      <div>
                        <h3>{user.fullName}</h3>
                        {/* <p>{user.last_msg}</p> */}
                        <p className="sidebar-user-lastmsg">
                          {user.last_msg?.length > 30 ? user.last_msg.substring(0, 30) + "..." : user.last_msg}
                        </p>
                      </div>
                      <div className="sidebar-user-time">
                        {new Date(user.last_message_sent_at).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>Loading user info...</p>
              )}
            </div>
          </div>

          {/* Chat Area */}
          <div className="main-chat-area">
            <div className="chat-header">
              <div className="chat-header-avatar">
                <img
                  src={selectedUser?.profilePhoto || messageuser2}
                  alt="User Profile"
                />
              </div>
              <div className="chat-header-info">
                {selectedUser ? (
                  <>
                    <h2>{selectedUser.fullName}</h2>
                    <p>{selectedUser.email}</p>
                  </>
                ) : (
                  <h2>Select a user to chat</h2>
                )}
              </div>
            </div>

            {/* Messages Display */}
            <div className="chat-messages">
              {messages.map((message, index) => (
                <div
                  key={index}
                  onClick={() => toggleTimestamp(index)}
                >
                  <div className="chat-all-messages">
                    {message.user.id !== parseInt(CURRENT_USER_ID) && (
                      <img src={selectedUser?.profilePhoto} alt="User" className="chat-message-avatar" />
                    )}
                    <div className={`chat-message ${message.user.id === parseInt(CURRENT_USER_ID) ? "chat-message-user" : "chat-message-other"}`}>
                      <p>{message.message}</p>
                    </div>
                  </div>

                  {/* <div> */}
                  {visibleTimestamp === index &&
                    (<span className={`chat-message ${message.user.id === parseInt(CURRENT_USER_ID) ? "chat-message-timestamp-user" : "chat-message-timestamp-other"}`}>{formatTimestamp(message.user.sent_at)}</span>)
                  }
                  {/* </div> */}
                </div>
              ))}
            </div>

            {/* Message Input */}
            {selectedUser && (
              <div className="chat-footer">
                <div className="input-container">
                  <input
                    type="text"
                    placeholder="Start a new message"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
                  // style={{ padding: "10px", width: "80%" }}
                  // className="kanj"
                  />
                  <img
                    src={messagesend}
                    alt="Send"
                    className="send-icon"
                    onClick={handleSendMessage}
                    style={{ cursor: "pointer", width: "25px", height: "25px" }}
                  />
                </div>
              </div>
            )}
          </div>

        </>)
      }
    </div>
  );
}